<template>
    <div>
        <admin-nav/>
        <router-view name="base"/>
    </div>
</template>

<script>
import AdminNav from '@components/layout/admin/Nav';

export default {
    head: {
        title: {
            inner: '1Autorent'
        },
        meta: [
            { name: 'application-name', content: '1Autorent' },
            { name: 'description', content: 'Autorent' },
            { itemprop: 'name', content: 'Autorent' },
            { itemprop: 'description', content: 'Autorent' },
            { property: 'og:title', content: 'Autorent' },
        ],
    },
    components: {
        AdminNav
    }
};
</script>
